function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { tableAnatomy as parts } from "@chakra-ui/anatomy";
export { Table, Thead, Tbody, Tfoot, Tr, Th, Td, TableCaption } from "@chakra-ui/react";
const baseStyle = {
    table: {
        fontVariantNumeric: 'lining-nums tabular-nums',
        borderCollapse: 'collapse',
        width: 'full'
    },
    th: {
        fontFamily: 'heading',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        letterSpacing: 'wider',
        textAlign: 'start'
    },
    td: {
        textAlign: 'start'
    },
    caption: {
        mt: 4,
        fontFamily: 'heading',
        textAlign: 'center',
        fontWeight: 'medium'
    }
};
const numericStyles = {
    '&[data-is-numeric=true]': {
        textAlign: 'end'
    }
};
const variantSimple = {
    th: _object_spread({
        color: 'text.neutral.secondary.default',
        borderBottom: '1px',
        borderColor: 'divider.neutral.primary.default',
        _dark: {
            borderColor: 'divider.neutral.primary.default'
        }
    }, numericStyles),
    td: _object_spread({
        borderBottom: '1px',
        borderColor: 'divider.neutral.primary.default',
        _dark: {
            borderColor: 'divider.neutral.primary.default'
        }
    }, numericStyles),
    caption: {
        color: 'text.neutral.secondary.default',
        _dark: {
            color: 'text.neutral.secondary.default'
        }
    },
    tfoot: {
        tr: {
            '&:last-of-type': {
                th: {
                    borderBottomWidth: 0
                }
            }
        }
    }
};
const variants = {
    simple: variantSimple,
    unstyled: {}
};
const small = {
    th: {
        px: 'spacing.l',
        py: 'spacing.xs',
        lineHeight: 'spacing.l',
        fontSize: 'xs'
    },
    td: {
        px: 'spacing.l',
        py: 'spacing.s',
        fontSize: 'sm',
        lineHeight: 'spacing.l'
    },
    caption: {
        px: 'spacing.l',
        py: 'spacing.s',
        fontSize: 'xs'
    }
};
const medium = {
    th: {
        px: 'spacing.xl',
        py: 'spacing.m',
        lineHeight: 'spacing.l',
        fontSize: 'xs'
    },
    td: {
        px: 'spacing.xl',
        py: 'spacing.l',
        lineHeight: '5'
    },
    caption: {
        px: 'spacing.xl',
        py: 'spacing.s',
        fontSize: 'sm'
    }
};
const sizes = {
    md: medium,
    medium,
    sm: small,
    small
};
const defaultProps = {
    variant: 'simple',
    size: 'medium'
};
export const ThemedTable = {
    parts: parts.keys,
    baseStyle,
    variants,
    sizes,
    defaultProps
};

//# sourceMappingURL=Table.js.map